// eslint-disable-next-line no-extend-native, @typescript-eslint/no-unnecessary-condition
Array.prototype.at ??= function at<T>(this: T[], idx: number) {
  return idx < 0 ? this[this.length + idx] : this[idx];
};
